<script lang="ts">
  import CurrentUserStore from "@shared/svelte/Stores/CurrentUserStore";
  import LayoutStore from "@shared/svelte/Stores/LayoutStore";
  import PickupOrDeliveryOutsideCart from "@retailer/svelte/Shared/PickupOrDeliveryOutsideCart.svelte";
  import { ProductLineListingStore } from "@retailer/svelte/ProductLines/ProductLineContainer/stores/ProductLineListingStore";
  import SkuItemPrices from "@shared/svelte/Components/ProductLines/ProductListCard/SkuItemPrices.svelte";
  import TrackingContext from "@shared/svelte/Components/Tracking/TrackingContext.svelte";
  import {
    CartWidgetTargetObjectBase,
    ProductCardSkuItemStockStatusEntity,
  } from "@shared/services/event_tracking/entities";
  import { getDataForInventory } from "@retailer/services/pricing_data_service";
  import { stagedRolloutCheck } from "@shared/svelte/Modules/StagedRolloutCheck.svelte";

  import type { Product, ProductLine, InventoryPrice } from "@shared/types/ProductLine";
  import ListsCartWidgetContainer from "@retailer/svelte/CartWidget/v2/Containers/ListsCartWidgetContainer.svelte";
  import { hideFulfillmentMethodPickerForDistributor } from "@retailer/services/fulfillment_methods_service";

  export let productLine: ProductLine;
  export let product: Product;
  export let Cart: any;
  export let productInventoryData: Product[] = [];
  export let trackingEntity: ProductCardSkuItemStockStatusEntity = null;

  const canShowCart = Cart && !$CurrentUserStore.limited_ordering;

  $: mobileMode = $LayoutStore.isMobile;

  const cartWidgetTargetObjectTypeBase = CartWidgetTargetObjectBase.PlpListView;

  const updateProductForPickupOrDelivery = () => {
    product = product;
  };

  const updateInventoryPriceData = (unitPrice, casePrice) => {
    ProductLineListingStore.update(n => {
      const { inventoryPrices } = n;
      if (inventoryPrices) {
        const inventoryData = inventoryPrices.find(p => p.inventory_id === product.inventory_id);
        if (inventoryData) {
          inventoryData.unit_price = unitPrice;
          inventoryData.case_price = casePrice;
        }
      }
      return n;
    });
  };

  const updatePricesErrorCb = (_err: any) => {
    updateInventoryPriceData(null, null);
  };

  const updatePrices = async () => {
    if (product?.distributor_info?.uses_warehouse_pickup) {
      let pricingData = await getDataForInventory(
        String(product.inventory_id),
        updatePricesErrorCb,
      );
      let price: InventoryPrice = pricingData?.inventory_price;
      if (price) {
        updateInventoryPriceData(price.unit_price, price.case_price);
        product.unit_price = price.unit_price;
        product.case_price = price.case_price;
      }
    }
  };
</script>

<style>
  /* ideally we use tailwind responsive attributes for this */
  @media screen and (min-width: 1024px) {
    .cart-widget-container {
      width: 200px;
    }
  }
</style>

<TrackingContext let:trackingContext>
  <div class:fizz-flex-vertical={!mobileMode} class:fizz-stack-8={mobileMode}>
    {#if canShowCart && !product.inventory_is_completely_out_of_stock && !stagedRolloutCheck("marketplace__fulfillment_methods") && !hideFulfillmentMethodPickerForDistributor(product?.distributor_info?.id)}
      <PickupOrDeliveryOutsideCart
        {product}
        {Cart}
        distributor={product.distributor_info}
        justify={mobileMode ? "start" : "end"}
        callback={() => {
          updateProductForPickupOrDelivery();
          updatePrices();
        }}
      />
    {/if}
    <div class:fizz-flex-row={!mobileMode} class:fizz-justify-end={!mobileMode}>
      <!-- mobileMode displays prices above the cart widget -->
      <!-- desktop includes prices in the cart widget component so that they don't get misaligned by the pickup location length-->
      {#if !mobileMode}
        <SkuItemPrices {product} {productLine} />
      {/if}

      {#if canShowCart}
        <div class="cart-widget-container" style="min-width:200px">
          <ListsCartWidgetContainer
            inventoryId={product.inventory_id}
            productId={product.id}
            {productLine}
            {productInventoryData}
            distributor={product.distributor_info}
            targetObjectTypeBase={cartWidgetTargetObjectTypeBase}
            trackingEntities={trackingContext.entities}
            on:openDrawer
            bind:trackingEntity
          />
        </div>
      {/if}
    </div>
  </div>
</TrackingContext>
